import {
  removeTrailingSlashes,
  getPathnameSuffix,
  removeRouterBasename,
} from '../../../../utils/locationUtils';

export const getNodeDetails = (pathname, routerBasename) => {
  const path = removeRouterBasename(
    removeTrailingSlashes(pathname),
    routerBasename,
  );
  const urlFormat = getPathnameSuffix(path);
  const prefixesPart = path.split('/');
  prefixesPart.pop();
  const prefix = prefixesPart.join('/');
  return { prefix, urlFormat, path };
};
